import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

import { getSortedFeatureKinds, hasDocuments } from "../helpers";

type NavigationProps = {
    product: FullProductApiModel;
    reviewsEnabled: boolean;
};

const Navigation = ({ product, reviewsEnabled }: NavigationProps) => {
    const { t } = useGranite();

    const hasFeatures = () => {
        return (
            getSortedFeatureKinds(product, t)
                .filter(f => !!f.name)
                .map(f => f.name).length > 0
        );
    };
    const hasDocumentsResult = hasDocuments(product);
    return (
        <nav className="product-info-nav">
            <div className="d-flex flex-row">
                <div className="text-center">
                    <a
                        href={`#${t("productDetail.anchor.hash.description")}`}
                        className="nav-link btn-link js-anchor-scroll-spy"
                    >
                        {t("productDetail.anchor.title.description")}
                    </a>
                </div>

                {hasFeatures() && (
                    <div className="text-center">
                        <a
                            href={`#${t("productDetail.anchor.hash.features")}`}
                            className="nav-link btn-link js-anchor-scroll-spy"
                        >
                            {t("productDetail.anchor.title.features")}
                        </a>
                    </div>
                )}

                {hasDocumentsResult && (
                    <div className="text-center">
                        <a
                            href={`#${t(
                                "productDetail.anchor.hash.documentation",
                            )}`}
                            className="nav-link btn-link js-anchor-scroll-spy"
                        >
                            {t("productDetail.anchor.title.documentation")}
                        </a>
                    </div>
                )}

                {reviewsEnabled && (
                    <div className="text-center">
                        <a
                            href={`#${t("productDetail.anchor.hash.reviews")}`}
                            className="nav-link btn-link js-anchor-scroll-spy"
                        >
                            {t("productDetail.anchor.title.reviews")}
                        </a>
                    </div>
                )}
            </div>
        </nav>
    );
};

export { Navigation };
